import { request } from '@/renderer/utils/api';

export type StripeOrderResponse = {
  calculated: {
    balanceUsed: number;
    plays: number;
    originalPrice: number;
    price: number;
  };
  ouuid: string;
  clientSecret?: string;
  doLocalPurchase?: boolean;
};

export type LocalOrderResponse = {
  calculated: {
    balanceUsed: number;
    plays: number;
    originalPrice: number;
    price: number;
  };
  orders: API.MembershipOrder[];
  ouuid: string;
};

export async function createStripeOrder(productId: string | number, index: number, affiliate = '') {
  return (
    await request<{ data: StripeOrderResponse }>(
      { input: `/api/v1/order`, method: 'POST' },
      {
        body: {
          productId: `${productId}.${index}`,
          method: 'stripe',
          affiliate,
        },
      },
    )
  ).data;
}

export async function createLocalOrder(productId: string | number, index: number) {
  return (
    await request<{ data: LocalOrderResponse }>(
      { input: `/api/v1/order/local/balance`, method: 'POST' },
      {
        body: {
          productId: `${productId}.${index}`,
          method: 'balance',
        },
      },
    )
  ).data;
}
